<template lang="pug">
	div
		.card
			.card-header.bg-light
				span.fa.fa-search.mr-2
				| Buscar cobros
			.card-body
				.row
					.col-xs-12.col-sm-6.col-md-6.col-lg-3.col-xl-3
						.form-group(v-if="permisos.cobros_verTodosCobros")
							label Agente
							input.form-control.form-control-sm(type="text", @keypress.enter="buscar", v-model="form.AgenteNombre")
						.form-group
							label Cliente
							input.form-control.form-control-sm(type="text", @keypress.enter="buscar", v-model="form.ClienteNombre")
					.col-xs-12.col-sm-6.col-md-6.col-lg-3.col-xl-2
						.form-group
							label Fecha inicio
							.input-group
								datepicker(
									@keypress.enter="buscar"
									minimum-view="month"
									v-model="form.FechaIni"
									input-class="form-control form-control-sm"
									format="MMMM, yyyy"
									maximum-view="year"
									:language='$dateLang'
									@input="buscar"
								)
								.input-group-append(@click="quitarFechaIni")
									button.btn.btn-danger.btn-sm
										span.fa.fa-trash
						.form-group
							label Fecha fin
							.input-group
								datepicker(
									@keypress.enter="buscar"
									minimum-view="month"
									v-model="form.FechaFin"
									input-class="form-control form-control-sm"
									format="MMMM, yyyy"
									maximum-view="year"
									:language='$dateLang'
									@input="buscar"
								)
								.input-group-append(@click="quitarFechaFin")
									button.btn.btn-danger.btn-sm
										span.fa.fa-trash
					.col-xs-12.col-sm-6.col-md-6.col-lg-3.col-xl-3
						.form-group
							label Contrato
							input.form-control.form-control-sm(type="text", @keypress.enter="buscar", v-model="form.contrato")
						.form-group
							label Usuario registra
							input.form-control.form-control-sm(type="text", @keypress.enter="buscar", v-model="form.usuario")
					.col-xs-12.col-sm-6.col-md-6.col-lg-3.col-xl-3
						.form-group
							label Estado
							br
							.btn-group
								button.btn(:class="(form.estado === null) ? 'btn-primary' : ''", @click="form.estado = null") Todos
								button.btn(:class="(form.estado === 'Pendiente') ? 'btn-primary' : ''", @click="form.estado = 'Pendiente'") Pendientes
								button.btn(:class="(form.estado === 'Pagado') ? 'btn-primary' : ''", @click="form.estado = 'Pagado'") Pagados
			.card-footer
				.row
					.col
						button.btn.btn-primary.btn-sm.m-1(@click="buscar()")
							span.fa.fa-search.mr-2
							| Buscar

						//- button.btn.btn-warning.btn-sm(@click="descargar('csv')")
						//- 	span.fa.fa-download.mr-2
						//- 	| CSV

						download-excel(
							class   = "btn btn-warning btn-sm m-1"
							:data   = "json_data"
							:fields = "json_fields"
							:meta   = "json_meta"
							name	= "filename.xls"
						)
							span.fa.fa-download.mr-2
							| XLS

					.col.text-right
						button.btn.btn-success.btn-sm(@click="nuevo()", v-if="permisos.cobros_crearCobros")
							span.fa.fa-plus.mr-2
							| Nuevo cobro
</template>
<script>
import { mapGetters } from 'vuex'
export default {
	props: ['form', 'resultados'],
	data: function () {
		return {

		}
	},

	created () {
		this.buscar()
	},

	computed: {
		...mapGetters({
			permisos: 'permisos/permisos'
		}),
		json_data () {
			if (!this.resultados) {
				return []
			}

			const arr = []

			for (let i = 0; i < this.resultados.length; i++) {
				arr[i] = JSON.parse(JSON.stringify(this.resultados[i]))
				arr[i]['fecha_cobro'] = new Date(this.resultados[i].fecha_cobro * 1000).toLocaleDateString()
				arr[i]['fecha_registro'] = new Date(this.resultados[i].fecha_registro * 1000).toLocaleDateString()
			}

			return arr
		},

		json_fields () {
			if (!this.resultados) {
				return {}
			}
			const f = {}
			for (let k in this.resultados[0]) {
				f[k] = k
			}
			return f
		},

		json_meta () {
			return [
				[{
					'key': 'charset',
					'value': 'utf-8'
				}]
			]
		}
	},

	methods: {
		quitarFechaIni () {
			this.form.FechaIni = null
			this.buscar()
		},
		quitarFechaFin () {
			this.form.FechaFin = null
			this.buscar()
		},
		buscar () {
			this.$emit('buscar')
		},
		descargar (tipo) {
			this.$emit('descargar', tipo)
		},
		nuevo () {
			this.$emit('nuevo')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/facturacion-cobros/vue/components/cobros/buscador.vue